export const removeEmptyRel = (content: string): string => {
  return content ? content.replace(/ rel="">/gi, ">") : "";
};
